import { render } from "./Recepciones.vue?vue&type=template&id=08e9ed85&scoped=true"
import script from "./Recepciones.vue?vue&type=script&lang=js"
export * from "./Recepciones.vue?vue&type=script&lang=js"

import "./Recepciones.vue?vue&type=style&index=0&id=08e9ed85&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e9ed85"]])

export default __exports__